let firstProgramaticScrollEventCalled = false;

const UserAction = {
  on: {
    onUserAction(callback: Function) {
      const removeListeners = () => {
        window.removeEventListener('click', clickListener);
        window.removeEventListener('scroll', scrollListener);
      };
      const clickListener = () => {
        callback(true);
        removeListeners();
      };

      const scrollListener = () => {
        if (!firstProgramaticScrollEventCalled) {
          firstProgramaticScrollEventCalled = true;
        } else {
          callback(true);
          removeListeners();
        }
      };

      try {
        window.addEventListener('click', clickListener);
        window.addEventListener('scroll', scrollListener);
      } catch (e) {}

      return () => {
        try {
          removeListeners();
        } catch (e) {}
      };
    },
  },
};

export default UserAction;
